import classnames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { authHeader } from '../../helpers/auth-header';
import { checkEmailIsValid, getApplicationType, getContactID, getSupplierID, handleConfirm, handleRequiredCheckAlt, handleSuccess, handleTimedSuccess, handleUpdateContactPortalDetails, pageEnabled, showCustomError, showError, useQuery } from '../../helpers/general';
import ChangePasswordModal from '../Auth/ChangePassword_Modal';
import BackToDashboard from '../controls/BackToDashboard';
import Select2 from '../controls/Select2';
import Translation from '../controls/Translation';

const $ = require('jquery');

const SupplierUser = () => {
    const [user, setUser] = useState({ supplierID: -1, contactID: -1 });
    const [activeTab, setActiveTab] = useState('tab-0');
    const [titles, setTitles] = useState([]);
    const [permissions, setPermissions] = useState([]);
    const [savedSearches, setSavedSearches] = useState([]);
    const [supplierUser, setSupplierUser] = useState({
        details: {
            title: '',
            firstName: '',
            lastName: '',
            fax: '',
            email: '',
            mobile: '',
            jobTitle: '',
            department: '',
            office: '',
            webUserName: '',
            sendDaily: false,
            preferredLanuage: 'en',
            includeNonUKTenders: false
        },
        permissions: null,
        hasEmailAlert: null,
        emailSearchAllowance: 0,
        selectedEmailSearch: []
    });
    const [loggedInUserPermissions, setLoggedInUserPermissions] = useState({ isUserAdmin: false, canChangePermissions: false, canUpdateContacts: false });
    const history = useHistory();
    const [isPageEnabled, setIsPageEnabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showChangePasswordModal, setShowChangePasswordModal] = useState(false);
    const [application, setApplication] = useState('');
    const [showNotificationsTab, setShowNotificationsTab] = useState(null);

    const toggleChangePassword = () => setShowChangePasswordModal(!showChangePasswordModal);

    let query = useQuery();
    let viewedUserId = query.get('uid');

    useEffect(() => {
        pageEnabled('[[CONTACT_NAME]]', '/dashboard').then(enabled => { setIsPageEnabled(enabled); });

        getApplicationType()
            .then(application => {
                setApplication(application);

                setUser(prev => ({
                    ...prev,
                    supplierID: getSupplierID(),
                    contactID: getContactID()
                }));
            });

        return () => {
            setUser({ supplierID: -1, contactID: -1 });
        }
    }, [])

    const toggle = tab => {
        if (activeTab !== tab) setActiveTab(tab);
    }

    const handleKeyDown = (e, index) => {
        const tabNodeList = document.querySelectorAll('[role="tab"]:not([hidden])');
        const tabIds = Array.from(tabNodeList).map(tab => tab.id);

        const currentTabId = `tab-${index}`;
        const currentIndex = tabIds.indexOf(currentTabId);

        let targetIndex = null;

        if (e.key === 'ArrowRight') {
            targetIndex = (currentIndex + 1) % tabIds.length;
        } else if (e.key === 'ArrowLeft') {
            targetIndex = (currentIndex - 1 + tabIds.length) % tabIds.length;
        } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            const panelId = `panel-${index}`;
            const panel = document.getElementById(panelId);
            if (panel && !panel.hasAttribute('hidden')) {
                panel.focus();
            }
            return;
        }

        if (targetIndex !== null) {
            e.preventDefault();
            const targetTabId = tabIds[targetIndex];
            toggle(targetTabId);

            const targetTab = document.getElementById(targetTabId);
            if (targetTab) {
                targetTab.focus();
            }
        }
    };

    useEffect(() => {
        if (user.contactID > 0 && application !== '') {
            fetch(`./SupplierUsers/GetNameTitles`, {
                method: 'GET',
                headers: authHeader(false, true)
            })
                .then(response => response.json())
                .then(data => {
                    let vTitles = [];

                    vTitles.push({ label: "Select..", value: "-1" });

                    data.map(obj => vTitles.push({ label: obj.title, value: obj.title }));
                    setTitles(vTitles);
                })
                .catch(error => console.log('Error: ', error));


            fetch(`./Permissions/GetAllContactPermissions`, {
                method: 'GET',
                headers: authHeader()
            })
                .then(response => response.json())
                .then(data => {
                    if (data) {
                        setPermissions(data);
                    }
                })
                .catch(error => console.log('Error: ', error));

            fetch(`./Permissions/IsUserAdmin?contactID=${user.contactID}`, {
                method: 'GET',
                headers: authHeader()
            })
                .then(response => response.json())
                .then(data => {
                    if (data) {
                        setLoggedInUserPermissions(prevState => ({ ...prevState, IsUserAdmin: data }));
                    }
                })
                .catch(error => console.log('Error: ', error));

            // If user is viewing their own profile
            if (parseInt(viewedUserId)) {

                if (user.contactID === Number(viewedUserId)) {
                    setLoggedInUserPermissions(prevState => ({ ...prevState, canUpdateContacts: true }));
                } else {
                    fetch(`./Permissions/CanUserChangeOtherUserDetails?contactID=${user.contactID}`, {
                        method: 'GET',
                        headers: authHeader()
                    })
                        .then(response => response.json())
                        .then(data => {
                            if (data) {
                                setLoggedInUserPermissions(prevState => ({ ...prevState, canUpdateContacts: data }));
                            }
                        })
                        .catch(error => console.log('Error: ', error));
                }
            }

            fetch(`./Permissions/CanUserChangePermissions?contactID=${user.contactID}`, {
                method: 'GET',
                headers: authHeader()
            })
                .then(response => response.json())
                .then(data => {
                    if (data) {
                        setLoggedInUserPermissions(prevState => ({ ...prevState, canChangePermissions: data }));
                    }
                })
                .catch(error => console.log('Error: ', error));

            if (user.supplierID > 0 && application !== '') {
                fetch(`./Suppliers/GetAllSupplierSavedSearches?supplierID=${user.supplierID}&contactID=${user.contactID}`, {
                    method: 'GET',
                    headers: authHeader(false, false)
                })
                    .then(response => response.json())
                    .then(data => {
                        setSavedSearches(data);
                    })

                    .catch(error => console.log('Error: ', error))
            }

            fetch(`./Settings/ArePackagesEnabled`, {
                method: 'GET',
                headers: authHeader(false, true)
            })
                .then(response => response.json())
                .then(packagesEnabled => {
                    setShowNotificationsTab(packagesEnabled);
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }, [application, user.contactID, user.supplierID, viewedUserId]);


    useEffect(() => {
        if (user.supplierID > 0 && viewedUserId) {
            fetch(`./SupplierUsers/GetUserAccount?userID=${viewedUserId}&supplierID=${user.supplierID}`, {
                method: 'GET',
                headers: authHeader(false, false)
            })
                .then(response => response.json())
                .then(data => {
                    if (data !== '') {
                        setSupplierUser(prevState => ({
                            ...prevState,
                            details: data.objData.details,
                            permissions: data.objData.permissions,
                            hasEmailAlert: data.objData.hasEmailAlert,
                            emailSearchAllowance: data.objData.emailSearchAllowance,
                            selectedEmailSearch: data.objData.selectedEmailSearch,
                        }));
                    }
                })
                .catch(err => console.log(err));
        } else if (user.supplierID === 0) {
            showError('AddSupplier', 'Error No User')
        }
    }, [history, user.supplierID, viewedUserId]);

    function handleChange(e) {
        const { name, type, checked, value } = e.target;
        const newValue = type === 'checkbox' ? checked : value;

        setSupplierUser(prev => ({
            ...prev,
            details: {
                ...prev.details,
                [name]: newValue
            }
        }));
    }


    function handlePermissionsChange(e, id) {
        const { checked } = e.target;

        setSupplierUser(prev => {
            const tmpPermissions = [...(prev.permissions || [])];
            const index = tmpPermissions.indexOf(id);

            if (checked && index === -1) {
                tmpPermissions.push(id);
            } else if (!checked && index > -1) {
                tmpPermissions.splice(index, 1);
            }

            return {
                ...prev,
                permissions: tmpPermissions
            };
        });
    }


    function handleSelectEmailSearches(e) {
        const { value, checked } = e.target;

        setSupplierUser(prev => {
            const tmpSelectedSearch = [...prev.selectedEmailSearch];
            const index = tmpSelectedSearch.indexOf(value);

            if (checked && index === -1) {
                tmpSelectedSearch.push(value);
            } else if (!checked && index > -1) {
                tmpSelectedSearch.splice(index, 1);
            }


            return {
                ...prev,
                selectedEmailSearch: tmpSelectedSearch
            };
        });
    }

    const handleSave = () => {
        let bProceedRegistering = true;
        let failedFields = [];

        $('.is-invalid').each(function (o, e) {
            bProceedRegistering = false;
            failedFields.push($(this).attr('id'))
        });

        $("input[required]").each(function (i, obj) {
            if ($(this).val() === '' && !$(this).hasClass('is-invalid')) {
                let fieldCheck = false;

                if (this.type === 'email') {
                    checkEmailIsValid($(this).attr('id'), $(this).val(), 'VALIDATION_default')
                        .then(vData => fieldCheck = vData);
                } else {
                    fieldCheck = handleRequiredCheckAlt($(this).attr('id'), $(this).val(), 'VALIDATION_default');
                }

                if (!fieldCheck) { failedFields.push($(this).attr('id')) }

                bProceedRegistering = bProceedRegistering && fieldCheck;
            }
        });

        if (bProceedRegistering) {
            if (viewedUserId) {
                handleConfirm(
                    viewedUserId > 0
                        ? `<p>Make changes to the account for ${supplierUser.details.firstName} ${supplierUser.details.lastName}?</p><hr /><p style={{marginBottom: "0.5em"}}><strong>PLEASE NOTE: </strong> This will update all your personal portal contact details you are linked with.<p>`
                        : `Would you like to create the account for ${supplierUser.firstName} ${supplierUser.lastName}?`,
                    function () {
                        saveDetails();
                    }
                );
            };
        } else {
            // Toggle tab of the first field to error
            let invalidInput = $(`#${failedFields[0]}`);
            let closest = invalidInput.closest('.tab-pane');
            let id = closest.attr('id');
            toggle(id);

            // Focus the field after a slight time out for rendering
            setTimeout(() => {
                document.getElementById(failedFields[0]).focus();
            }, 100);

            showCustomError('There is a problem with the information you are trying to save - please review any errors on screen and try again.', 'Cannot Save Details', 'error');
        }
    }

    const saveDetails = () => {
        if (viewedUserId) {
            fetch(`./SupplierUsers/UpdateSupplierUser?contactID=${viewedUserId}&supplierID=${user.supplierID}&loggedInUser=${user.contactID}`, {
                method: 'POST',
                headers: authHeader(),
                body: JSON.stringify(supplierUser)
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success === true) {
                        handleUpdateContactPortalDetails(user.contactID);
                    } else {
                        showCustomError(data.message, 'Problem Updating Contact', 'error');
                    }
                })
                .catch(err => {
                    console.log('Error');
                });
        } else {
            if (application !== '') {
                fetch(`./SupplierUsers/CreateNewSupplierUser?supplierID=${user.supplierID}&systemName=${application}`, {
                    method: 'POST',
                    headers: authHeader(false, false),
                    body: JSON.stringify(supplierUser)
                })
                    .then(response => response.json())
                    .then(data => {
                        if (data.success === true) {
                        } else {
                            console.log('Error');
                            showError(data.error, data.message);
                        }
                    })
                    .catch(err => {
                        console.log('Error::', err);
                    });
            }
        }
    }

    const handleOpenChangePassword = () => {
        setIsLoading(true)
        toggleChangePassword();
    }

    const handleChangeNotifications = () => {
        if (viewedUserId) {
            fetch(`./SupplierUsers/UpdateSupplierUserNotifications?contactID=${viewedUserId}&supplierID=${user.supplierID}&loggedInUser=${user.contactID}`, {
                method: 'POST',
                headers: authHeader(),
                body: JSON.stringify(supplierUser)
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success === true) {
                        handleTimedSuccess('success', 'Notifications updated', 'Your notification settings have been updated');
                    } else {
                        showCustomError(data.message, 'Problem Updating Notification Settings', 'error');
                    }
                })
                .catch(err => {
                    console.log('Error');
                });
        } else {
            showCustomError("<p>There was a problem updating the notification settings.  Please try again.</p><p>If the problem persists, trying logging out and back in.</p>", 'Problem Updating Notification Settings', 'error');
        }
    }

    const handleChangePermissions = () => {
        if (viewedUserId) {
            fetch(`./SupplierUsers/UpdateSupplierUserPermissions?contactID=${viewedUserId}&supplierID=${user.supplierID}&loggedInUser=${user.contactID}`, {
                method: 'POST',
                headers: authHeader(),
                body: JSON.stringify(supplierUser)
            })
                .then(response => response.json())
                .then(data => {
                    if (data.success === true) {
                        handleTimedSuccess('success', 'Notifications updated', 'Your permission settings have been updated');
                    } else {
                        showCustomError(data.message, 'Problem Updating Notification Settings', 'error');
                    }
                })
                .catch(err => {
                    console.log('Error');
                });
        } else {
            showCustomError("<p>There was a problem updating the notification settings.  Please try again.</p><p>If the problem persists, trying logging out and back in.</p>", 'Problem Updating Notification Settings', 'error');
        }
    }


    if (isPageEnabled === true && supplierUser && supplierUser.details) {
        return (
            <>
                <Card className='main-content__inner'>
                    <BackToDashboard />

                    <CardBody>
                        <Card className='c-card u-component-spacing'>
                            <CardBody>
                                <h2 className='c-broken-underline'>
                                    {user.contactName}
                                </h2>
                                <div className='tabs u-component-spacing--2x'>
                                    <Nav tabs role="tablist">
                                        <NavItem role="presentation">
                                            <NavLink
			                                    role='tab'
                                                className={classnames({ active: activeTab === 'tab-0' })}
                                                id='tab-0'
                                                data-toggle='tab'
                                                href='#panel-0'
                                                aria-label='details'
                                                onClick={(e) => { e.preventDefault(); toggle('tab-0'); }}
                                                {...(activeTab === 'tab-0'
                                                    ? { 'aria-selected': 'true' }
                                                    : { tabIndex: -1 })}
                                                onKeyDown={(e) => handleKeyDown(e, 0)}
                                            >
                                                <Translation ID='Details' />
                                            </NavLink>
                                        </NavItem>
                                        <NavItem role="presentation">
                                            <NavLink
			                                    role='tab'
                                                className={classnames({ active: activeTab === 'tab-1' })}
                                                id='tab-1'
                                                data-toggle='tab'
                                                href='#panel-1'
                                                aria-label='contact details'
                                                onClick={(e) => { e.preventDefault(); toggle('tab-1'); }}
                                                {...(activeTab === 'tab-1'
                                                    ? { 'aria-selected': 'true' }
                                                    : { tabIndex: -1 })}
                                                onKeyDown={(e) => handleKeyDown(e, 1)}
                                            >
                                                <Translation ID='ContactDetails' />
                                            </NavLink>
                                        </NavItem>
                                        {showNotificationsTab === true &&
                                            <NavItem role="presentation">
                                                <NavLink
			                                        role='tab'
                                                    className={classnames({ active: activeTab === 'tab-2' })}
                                                    id='tab-2'
                                                    data-toggle='tab'
                                                    href='#panel-2'
                                                    aria-label='notification settings'
                                                    onClick={(e) => { e.preventDefault(); toggle('tab-2'); }}
                                                    {...(activeTab === 'tab-2'
                                                        ? { 'aria-selected': 'true' }
                                                        : { tabIndex: -1 })}
                                                    onKeyDown={(e) => handleKeyDown(e, 2)}
                                                >
                                                    <Translation ID='NotificationSettings' />
                                                </NavLink>
                                            </NavItem>
                                        }
                                        <NavItem role="presentation">
                                            <NavLink
			                                    role='tab'
                                                className={classnames({ active: activeTab === 'tab-3' })}
                                                id='tab-3'
                                                data-toggle='tab'
                                                href='#panel-3'
                                                aria-label='contact permissions'
                                                onClick={(e) => { e.preventDefault(); toggle('tab-3'); }}
                                                {...(activeTab === 'tab-3'
                                                    ? { 'aria-selected': 'true' }
                                                    : { tabIndex: -1 })}
                                                onKeyDown={(e) => handleKeyDown(e, 3)}
                                            >
                                                <Translation ID='Permissions' />
                                            </NavLink>
                                        </NavItem>
                                    </Nav>
                                </div>

                                <TabContent activeTab={activeTab}>
                                    <TabPane id='panel-0' role="tabpanel" aria-labelledby="tab-0" tabId='tab-0' {...(activeTab !== 'tab-0' && { hidden: true })} tabIndex="-1">
                                        <div className='tab-pane__inner'>
                                            <div className='c-form'>
                                                {(loggedInUserPermissions.IsUserAdmin || Number(viewedUserId) === Number(user.contactID)) &&
                                                    <input id="changePassword" type="submit" className="c-cta u-component-spacing" style={{ width: "15em" }} value="Change Password" onClick={() => handleOpenChangePassword()} />
                                                }

                                                {titles && Object.keys(titles).length !== 0 && Object.keys(supplierUser.details).length !== 0 &&
                                                    <div className='c-form__input-group'>
                                                        <label className='c-form__label' htmlFor='title'>
                                                            <Translation ID='Title' />
                                                        </label>
                                                        <Select2
                                                            id={'title'}
                                                            options={titles}
                                                            defaultValue={supplierUser.details.title}
                                                            change={(e) => handleChange(e)}
                                                            disabled={!loggedInUserPermissions.canUpdateContacts}
                                                        />
                                                    </div>
                                                }

                                                <div className='c-form__input-group'>
                                                    <label className='c-form__label' htmlFor='firstName'>
                                                        <Translation ID='FirstName' />
                                                    </label>
                                                    <input name='firstName' id='firstName' type='text' className='c-form__input' disabled={!loggedInUserPermissions.canUpdateContacts} defaultValue={supplierUser.details.firstName} onChange={(e) => handleChange(e)} />
                                                </div>

                                                <div className='c-form__input-group'>
                                                    <label className='c-form__label' htmlFor='lastName'>
                                                        <Translation ID='LastName' />
                                                    </label>
                                                    <input name='lastName' id='lastName' type='text' className='c-form__input' disabled={!loggedInUserPermissions.canUpdateContacts} defaultValue={supplierUser.details.lastName} onChange={(e) => handleChange(e)} />
                                                </div>

                                                <div className='c-form__input-group'>
                                                    <label className='c-form__label' htmlFor='jobTitle'>
                                                        <Translation ID='JobTitle' />
                                                    </label>
                                                    <input name='jobTitle' id='jobTitle' type='text' className='c-form__input' disabled={!loggedInUserPermissions.canUpdateContacts} defaultValue={supplierUser.details.jobTitle} onChange={(e) => handleChange(e)} />
                                                </div>

                                                <div className='c-form__input-group'>
                                                    <label className='c-form__label' htmlFor='department'>
                                                        <Translation ID='Department' />
                                                    </label>
                                                    <input name='department' id='department' type='text' className='c-form__input' disabled={!loggedInUserPermissions.canUpdateContacts} defaultValue={supplierUser.details.department} onChange={(e) => handleChange(e)} />
                                                </div>
                                            </div>
                                        </div>
                                    </TabPane>
                                    <TabPane id='panel-1' role="tabpanel" aria-labelledby="tab-1" tabId='tab-1' {...(activeTab !== 'tab-1' && { hidden: true })} tabIndex="-1">
                                        <div className='tab-pane__inner'>
                                            <div className='c-form'>
                                                <div className='c-form__input-group'>
                                                    <Translation ID='TelephoneNumber' htmlFor='telephone' />
                                                    <input name='telephone' id='telephone' type='text' className='c-form__input' disabled={!loggedInUserPermissions.canUpdateContacts} defaultValue={supplierUser.details.telephone} onChange={(e) => handleChange(e)} />
                                                </div>

                                                <div className='c-form__input-group'>
                                                    <Translation ID='MobileNumber' htmlFor='mobile' />
                                                    <input name='mobile' id='mobile' type='text' className='c-form__input' disabled={!loggedInUserPermissions.canUpdateContacts} defaultValue={supplierUser.details.mobile} onChange={(e) => handleChange(e)} />
                                                </div>

                                                <div className='c-form__input-group'>
                                                    <Translation ID="EmailAddress" required={true} htmlFor='email' />
                                                    <input name="email" type="email" defaultValue={supplierUser.details.email} id="email" className='c-form__input form-control' disabled={true} />
                                                </div>
                                            </div>
                                        </div>
                                    </TabPane>
                                    <TabPane id='panel-2' role="tabpanel" aria-labelledby="tab-2" tabId='tab-2' {...(activeTab !== 'tab-2' && { hidden: true })} tabIndex="-1">
                                        {supplierUser.hasEmailAlert !== null &&
                                            <div className='tab-pane__inner'>
                                                {supplierUser.hasEmailAlert === true &&
                                                    <div className='c-form'>
                                                        <div className="c-form__input-group">
                                                            <div className="">
                                                                <input id="sendDaily" name="sendDaily" type="checkbox" className="custom-control-input" defaultChecked={supplierUser.details.sendDaily} onChange={(e) => handleChange(e)} />
                                                                <Translation ID="ReceiveDailyEmails" htmlFor='sendDaily' customClass='c-search-section__label c-checkbox-label' />
                                                            </div>
                                                        </div>

                                                        {supplierUser.details.sendDaily === true && savedSearches && Object.keys(savedSearches).length !== 0 &&
                                                            <>
                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                                                    <Translation ID='SelectSaveSearches' StringOnly={true} />
                                                                    {supplierUser.emailSearchAllowance > -1 &&
                                                                        <span>
                                                                            <i>({supplierUser.selectedEmailSearch.length} / {supplierUser.emailSearchAllowance} selected)</i>
                                                                        </span>
                                                                    }
                                                                </div>
                                                                <div className='c-form'>
                                                                    {savedSearches.map((savedSearch, i) => {
                                                                        return (
                                                                            <div className="c-form__input-group" style={{ maxWidth: "100% !important" }} key={i}>
                                                                                <div className="custom-checkbox custom-control" style={{ marginLeft: "10%" }}>
                                                                                    <input id={`search_${savedSearch.searchID}`} name={`search_${savedSearch.searchID}`}
                                                                                        value={savedSearch.searchID}
                                                                                        type="checkbox"
                                                                                        className="custom-control-input"
                                                                                        disabled={supplierUser.emailSearchAllowance > -1 && (supplierUser.selectedEmailSearch.length >= supplierUser.emailSearchAllowance && !supplierUser.selectedEmailSearch.includes(savedSearch.searchID))}
                                                                                        defaultChecked={supplierUser.selectedEmailSearch.includes(savedSearch.searchID)}
                                                                                        onChange={(e) => handleSelectEmailSearches(e)}
                                                                                    />
                                                                                    <label htmlFor={`search_${savedSearch.searchID}`} className='c-search-section__label c-checkbox-label' style={
                                                                                        supplierUser.emailSearchAllowance > 0 && (supplierUser.selectedEmailSearch.length >= supplierUser.emailSearchAllowance && !supplierUser.selectedEmailSearch.includes(savedSearch.searchID))
                                                                                            ? { color: "grey" }
                                                                                            : {}
                                                                                    }>{savedSearch.searchDescription}</label>
                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })
                                                                    }
                                                                </div>
                                                            </>
                                                        }
                                                        <input id="changeNotifications" type="submit" className="c-cta u-component-spacing" style={{ width: "18em" }} value="Update Notification Settings" onClick={() => handleChangeNotifications()} />
                                                    </div>
                                                }

                                                {supplierUser.hasEmailAlert === false &&
                                                    <>
                                                        <h5 className="c-page-title u-component-spacing--1x">
                                                            <Translation ID='PackageDoesNotSupportDailyEmails' />
                                                        </h5>
                                                        <button className="c-tender-actions__action-button c-tender-actions__action-button--upgrade u-component-spacing--2x" onClick={() => history.push(`/upgrade`)}>
                                                            <Translation ID='UpgradePackage' htmlFor='' />
                                                        </button>
                                                    </>
                                                }
                                            </div>
                                        }
                                    </TabPane>
                                    <TabPane id='panel-3' role="tabpanel" aria-labelledby="tab-3" tabId='tab-3' {...(activeTab !== 'tab-3' && { hidden: true })} tabIndex="-1">
                                        {supplierUser.permissions !== null &&
                                            <div className='tab-pane__inner'>
                                                <div className='c-form'>
                                                    {supplierUser.permissions.includes(1) &&
                                                        <h4>
                                                            <Translation ID='AdministratorAccount' />
                                                        </h4>
                                                    }
                                                    {!supplierUser.permissions.includes(1) && Object.keys(permissions).length > 0 &&
                                                        <>
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                                                                <Translation ID='SelectPermissions' StringOnly={true} />
                                                            </div>
                                                            {permissions.map((permission, i) => {
                                                                if (permission.permissionID !== 1) {
                                                                    return (
                                                                        <div className='c-form__input-group' key={i}>
                                                                            <div className="custom-checkbox custom-control" style={{ marginLeft: "10%" }}>
                                                                                <input name={`permission${permission.permissionID}`} disabled={!loggedInUserPermissions.canChangePermissions}
                                                                                    type='checkbox'
                                                                                    id={`permission${permission.permissionID}`}
                                                                                    className="custom-control-input"
                                                                                    defaultChecked={supplierUser.permissions.includes(Number(permission.permissionID))}
                                                                                    onChange={(e) => handlePermissionsChange(e, permission.permissionID)}
                                                                                />
                                                                                <label htmlFor={`permission${permission.permissionID}`} className='c-search-section__label c-checkbox-label' >{permission.description}</label>
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                } else {
                                                                    return null;
                                                                }
                                                            })}
                                                        </>
                                                    }

                                                    {(!supplierUser.permissions.includes(1) && loggedInUserPermissions.canChangePermissions) &&
                                                        <input id="changeNotifications" type="submit" className="c-cta u-component-spacing" style={{ width: "15em" }} value="Update Permissions" onClick={() => handleChangePermissions()} />
                                                    }
                                                </div>
                                            </div>
                                        }
                                    </TabPane>
                                </TabContent>

                                {(loggedInUserPermissions.canUpdateContacts || loggedInUserPermissions.canChangePermissions) &&
                                    <div className='u-flex-end u-component-spacing'>
                                        <button type='button' className='c-form__submit' onClick={() => handleSave()}>
                                            <Translation ID='SaveDetails' />
                                        </button>
                                    </div>
                                }
                            </CardBody>
                        </Card>
                    </CardBody>
                </Card>

                <ChangePasswordModal
                    isOpen={showChangePasswordModal}
                    toggle={toggleChangePassword}
                    isLoading={isLoading}
                    setIsLoading={setIsLoading}
                    isCurrentUserAdmin={loggedInUserPermissions.IsUserAdmin}
                    contactID={viewedUserId}
                />
            </>
        );
    } else {
        return null;
    }
}

export default SupplierUser;